import { FC } from "react";
import { useSelector } from "react-redux";
import { useLoaderData, useNavigate, LoaderFunctionArgs } from "react-router-dom";
import styled from "styled-components";
import MainContainer from "../components/ui_components/MainContainer";
import { apiGetArena } from "../components/ui_components/ApiList";
import AllPPvListArena from "../components/arena_components/AllPPvListArena";
import type { RootState, Arena as ArenaType } from "../types";

const BoxPoster = styled.div`
    width: 50%;
    height: 250px;
    border: 1px solid black;
    margin-bottom: 10px;

    @media screen and (max-width: 768px) {
        width: 80%;
        height: 150px;
    }

    & img {
        width: 100%;
        height: 100%;
    }
`;

const BoxListPpv = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 10px 0 20px 0;
`;

const Arena: FC = () => {
    const { user } = useSelector((state: RootState) => state.auth);
    const arenaData = useLoaderData() as ArenaType;
    const navigate = useNavigate();

    const navigateGoToEditArenaPage = (): void => {
        const url = '/arenas/edit/' + arenaData.id;
        navigate(url);
    };

    return (
        <MainContainer>
            <div className="container d-flex flex-column align-items-center justify-content-center pt-2">
                <h1>{arenaData.name}</h1>
                <p>
                    {arenaData.state}, {arenaData.city}
                </p>

                {!!(user && (user.is_admin || user.is_founder || user.is_super_admin)) && (
                    <div className="btn-edit btn btn-primary me-2 mb-2" onClick={() => navigateGoToEditArenaPage()}>
                        Modifica
                    </div>
                )}

                <BoxPoster>
                    <img
                        src={process.env.REACT_APP_STORAGE_URL + arenaData.img_path}
                        alt={arenaData.img_path + "_alt"}
                    />
                </BoxPoster>

                <BoxListPpv className="box-list-ppv">
                    <h2>PPV Ospitati</h2>
                    {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
                    <AllPPvListArena listPpv={(arenaData.ppvs || []) as any} />
                </BoxListPpv>
            </div>
        </MainContainer>
    );
};

export default Arena;

export async function loader({ params }: LoaderFunctionArgs): Promise<ArenaType> {
    const response = await apiGetArena(Number(params.id));
    return response;
}
